import { ErrorBoundary } from '@sentry/react'
import React from 'react'

import ConnectionFilters from '@components/ConnectionFilters'
import { ModalFiltersProps } from '@components/ConnectionFilters/ModalFilters'
import SkeletonFilter from '@components/ConnectionFilters/Skeleton'
import useIsMobile from '@hooks/useIsMobile'
import { withPluginSlot } from '@plugins/index'

export interface JourneyListFiltersColumnProps extends ModalFiltersProps {
  isContentLoading: boolean
}

const JourneyListFiltersColumn = (props: JourneyListFiltersColumnProps) => {
  const { isContentLoading } = props
  const isMobile = useIsMobile()

  return (
    <ErrorBoundary fallback={() => <></>}>
      <div className="journey-list__filters column">
        {isContentLoading && !isMobile && <SkeletonFilter />}
        {!isContentLoading && <ConnectionFilters {...props} />}
      </div>
    </ErrorBoundary>
  )
}

export default withPluginSlot(JourneyListFiltersColumn, 'journeyListFiltersColumn')
